import { render, staticRenderFns } from "./InfoTable.vue?vue&type=template&id=3aee07ea&scoped=true&lang=html&"
import script from "./InfoTable.vue?vue&type=script&lang=js&"
export * from "./InfoTable.vue?vue&type=script&lang=js&"
import style0 from "./InfoTable.vue?vue&type=style&index=0&id=3aee07ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aee07ea",
  null
  
)

export default component.exports